<template>
  <div class="page_num">
    <el-pagination prev-text='上一页' :current-page.sync="currentPage" @current-change='currentChange' next-text='下一页'
      background layout="prev, pager, next" hide-on-single-page :page-size='pageSize' :total="pageTotal">
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: "PageNum",
  props: {
    //当前页
    currentPage1: {
      type: Number,
      default() {
        return 1;
      }
    },

    //总页数
    pageTotal: {
      type: Number,
      default() {
        return 10;
      }
    },

    //每页显示数量
    pageSize: {
      type: Number,
      default() {
        return 10;
      }
    }
  },

  data() {
    return {
      currentPage: 1
    };
  },

  watch: {
    currentPage(newValue) {
      this.$emit("update:currentPage1", newValue);
    },

    currentPage1(newValue) {
      this.currentPage = newValue;
    }
  },
  methods: {
    currentChange(currentPage) {
      this.$emit("currentChange", currentPage);
    }
  }
};
</script>


<style lang='less' scoped>
.page_num {
  //底部页码样式修改```````````````````
  .el-pagination {
    display: flex;

    /deep/.el-pager {
      width: auto;
    }

    /deep/.el-pager > .number {
      min-width: 34px;
      min-height: 34px;
      line-height: 34px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(204, 204, 204, 1);
      border-radius: 4px;
      background-color: #fff;
    }

    /deep/.el-pager .number:hover {
      transform: translate3d(0, -2px, 0);
      color: #24ba58;
    }

    /deep/.el-pager > .number.active {
      background-color: #24ba58;
    }

    /deep/.el-pager > .number.active:hover {
      cursor: pointer;
      transform: translate3d(0, 0, 0);
      color: #fff;
    }

    /deep/.btn-prev,
    /deep/.btn-next {
      width: 81px;
      height: 34px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(204, 204, 204, 1);
      border-radius: 4px;

      span {
        width: 81px;
        height: 34px;
        line-height: 34px;
      }
    }

    /deep/.btn-prev:hover,
    /deep/.btn-next:hover {
      transform: translate3d(0, -2px, 0);
      color: #24ba58;
    }

    /deep/.btn-prev[disabled],
    /deep/.btn-next[disabled] {
      transform: translate3d(0, 0, 0);
      color: #c0c4cc;
    }

    /deep/.el-icon {
      width: 34px;
      height: 34px;
      background-color: #edeff1;
    }

    /deep/.el-icon:hover {
      color: #24ba58 !important;
    }

    /deep/.el-pager .more::before {
      line-height: 34px;
    }
  }
  //底部页码样式修改```````````````````
}
</style>